import { createSvgIcon } from "@mui/material";

const SigmaIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none">
    <path
      d="M13.6574 4.16699H7.4959C6.59374 4.16699 6.15284 5.26743 6.80542 5.89035L10.7322 9.63865C10.9386 9.83562 10.9386 10.165 10.7322 10.362L6.80542 14.1103C6.15284 14.7332 6.59374 15.8337 7.4959 15.8337H14.1667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>,
  "SigmaIcon"
);

export default SigmaIcon;
